module.exports = __webpack_public_path__ + "static/WEDDING E&M-536-6b0954e30da580ad88ecaa7398931808.jpg";